// PATH IN YOUR PROJECT: src/components/Header/ActiveCityBadge/ActiveCityBadge.js
import React from "react"
import PropTypes from "prop-types"

/**
 * ActiveCityBadge
 * ------------------------------------------------------------------
 * Shows the user's currently active city in the header. Rendered as
 * a button so it can optionally open a city switcher, but degrades
 * gracefully to a static badge if no onClick is passed.
 *
 * @param {string} iconSrc - path to the icon image
 * @param {string} label - small muted line, e.g. "Active City"
 * @param {string} value - bold city line, e.g. "Dallas, TX"
 */
const ActiveCityBadge = ({ iconSrc, label = "Active City", value, onClick }) => {
  const Tag = onClick ? "button" : "div"

  return (
    <Tag
      type={onClick ? "button" : undefined}
      className="active-city"
      onClick={onClick}
      aria-label={onClick ? `${label}: ${value}. Change city` : undefined}
    >
      <img src={iconSrc} alt="" className="active-city__icon" />
      <span className="active-city__text">
        <span className="active-city__label">{label}</span>
        <span className="active-city__value">{value}</span>
      </span>
    </Tag>
  )
}

ActiveCityBadge.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

export default ActiveCityBadge